<script lang="ts">
    import type {SpacerDirection, Spacing} from './types';
    import {getSpacingCssValue} from './types';
    import {exists} from 'shared/utils/custom-utils';

    export let direction: SpacerDirection = 'vertical';
    export let size: Spacing = '0';
    export let flex: number | string | null = null;
</script>

<div class="kp-spacer"
     style:--flex={flex}
     style:width={direction === 'vertical' ? '0' : getSpacingCssValue(size)}
     style:height={direction === 'vertical' ? getSpacingCssValue(size) : '0'}
     class:uses-flex={exists(flex)}>
</div>

<style>
    .kp-spacer {
        flex-shrink: 0;
    }

    .kp-spacer.uses-flex {
        flex: var(--flex);
    }
</style>